import * as yup from 'yup';

export default () => {
  return yup.object({
    id: yup.string().required('Required'),
    utilize: yup.string(),
    rule: yup.string().required('Required'),
    value1: yup
      .number()
      .transform((currentValue, originalValue) => {
        return originalValue === '' ? 0 : currentValue;
      })
      .typeError('Must be a number'),
    value2: yup
      .number()
      .transform((currentValue, originalValue) => {
        return originalValue === '' ? 0 : currentValue;
      })
      .typeError('Must be a number')
  });
};
